// extracted by mini-css-extract-plugin
export var bookingLabel = "index-module--bookingLabel--hZbkl";